import type { Member } from '../types';

/** True when the member must complete contact info before using the app. */
export function needsProfileCompletion(member: Member | null | undefined): boolean {
  if (!member) return false;
  const phone = member.phone?.trim();
  return !phone;
}
